import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicVaccinationCancellationConfirmation, {
	ElectronicVaccinationCancellationConfirmationValues,
} from './ElectronicVaccinationCancellationConfirmation';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (
		values: ElectronicVaccinationCancellationConfirmationValues,
	) => void;
}

const ElectronicVaccinationCancellationConfirmationModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header
				title='nczi.electronicVaccinationCancellationConfirmation.cancelRecord'
				firstUpper
			/>
			<Modal.Content contentScroll>
				<ElectronicVaccinationCancellationConfirmation onSubmit={onSubmit} />
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicVaccinationCancellationConfirmationModal;
